import React from 'react';
import Text from './base';

const H2 = props => <Text defaultTag="h2" variant="h2" {...props} />;

export default H2;
